import styled, { css } from 'styled-components';
import { theme } from '../../styles/theme';
import DefaultButton from './DefaultButton';
import { IDefaultButtonProps } from './types';

const SecondaryButton = styled(DefaultButton)<IDefaultButtonProps>`
  ${({ isOutlined }) =>
    isOutlined
      ? css`
          --button-text-c: ${theme.colors.secondary800};
          --button-text-hover-c: ${theme.colors.secondary900};
        `
      : css`
          --button-bg-c: #eff0f6;
          --button-text-c: ${theme.colors.secondary800};
          --button-text-hover-c: ${theme.colors.secondary900};
          --button-bg-hover-c: #ebecf2;
          body.dark & {
            --button-bg-c: #3a3c49;
            --button-bg-hover-c: #464960;
          }
        `}
`;

export default SecondaryButton;
